export const DELETED_PROFILE_PLACEHOLDER = {
    firstName: 'Deleted',
    lastName: 'Profile',
};
export const BOT_NAMES = {
    portal_bot: 'ProVision Bot',
};
